import { render } from "./IncomesFlatRateTax.vue?vue&type=template&id=e82a4d88&scoped=true"
import script from "./IncomesFlatRateTax.vue?vue&type=script&lang=js"
export * from "./IncomesFlatRateTax.vue?vue&type=script&lang=js"

import "./IncomesBodyStyle.css?vue&type=style&index=0&id=e82a4d88&scoped=true&lang=css"
import "./IncomesFlatRateTax.vue?vue&type=style&index=1&id=e82a4d88&scoped=true&lang=css"

import exportComponent from "C:\\AgentIFAS\\_work\\33\\s\\Nezivotko.Web2\\CreditWorthiness\\real-world-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e82a4d88"]])

export default __exports__